enum SpeakerSectionTypes {
  Landing = 'landing',
  Live = 'live',
}

export default SpeakerSectionTypes
